import { useToast } from "contexts/ToastContext";
import { useState } from "react";
import { updateLegislativeDrafting } from "services/legislativeService";
import ShowUI, { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { LoadingIcon } from "utils/constant";
import { LAW_IMPLEMENTATION_REQUEST_STATUS, LEGAL_AWAERENESS_REQUEST_STATUS, LEGISLATIVE_DRAFTING_REQUEST_STATUS } from "utils/constantValues";
import UploadDraftLaw from "./uploadDraftLaw";
import UploadResearchData from "./uploadRequestForAdditionalInfo";
import { useTranslation } from "react-i18next";

export default function ProsecutorRemark({ setFormState, formState }: { setFormState: any, formState: any }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleFeedbackCloseModal = () => {
        setIsFeedbackModalOpen(false);
    }
    const handleTargetCloseModal = () => {
        setIsTargetModalOpen(false);
    }
    const handleRequestCloseModal = () => {
        setIsRequestModalOpen(false);
    }

    const handleReject = () => {
    }

    const handleUploadProposalClick = () => {
    }

    // Get button text for Legal Awareness Summary button
    const getSummaryButtonText = () => {
        if (formState.current_approval_status === LEGAL_AWAERENESS_REQUEST_STATUS.summary_submitted.value) {
            return t("ReUploadLegalAwarenessSummary") || "ReUpload Legal Awareness Summary";
        }
        return t("UploadLegalAwarenessSummary") || "Upload Legal Awareness Summary";
    };

    // Get button text for Awareness Outcome button
    const getOutcomeButtonText = () => {
        if (formState.current_approval_status === LEGAL_AWAERENESS_REQUEST_STATUS.outcome_submitted.value) {
            return t("ReUploadAwarenessOutcome") || "ReUpload Awareness Outcome";
        }
        return t("UploadAwarenessOutcome") || "Upload Awareness Outcome";
    };

    return (
        <>
            <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3">
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.upload_audit_target.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <button
                        type="button"
                        className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-[#0A1D39] text-[#0A1D39] text-sm font-semibold hover:bg-[#0A1D39] hover:text-white focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/30 transition-colors disabled:opacity-50"
                        onClick={() => setIsTargetModalOpen(true)}
                        disabled={loading}
                    >
                        {loading ? (
                            <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                {getSummaryButtonText()}
                            </>
                        )}
                    </button>
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.awareness_outcome.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <button
                        type="button"
                        className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A1D39] text-white text-sm font-semibold shadow-sm hover:bg-[#13294d] focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/40 transition-colors disabled:opacity-50"
                        onClick={() => setIsModalOpen(true)}
                        disabled={loading}
                    >
                        {loading ? (
                            <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                                {getOutcomeButtonText()}
                            </>
                        )}
                    </button>
                </ShowUI>
            </div>
            <UploadDraftLaw
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isTargetModalOpen}
                onClose={handleTargetCloseModal}
                onUploadProposal={handleUploadProposalClick}
            />
            <UploadDraftLaw
                request={formState}
                setLegalResearch={setFormState}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onUploadProposal={handleUploadProposalClick}
                type="awareness"
            />
        </>
    );
}